import { resolvedPersonalSheet, parseSheetAmount, PERSONAL_FIELDS } from './personal-sheet'
import { FINANCE_LIMIT_ITEMS } from './finance-limits'
import { buildFinanceSummary } from './finance-summary'

export const isSheetBlank = value => value == null || String(value).trim() === ''
export const isNoChild = value => String(value == null ? '' : value).trim() === 'いない'

export function validatePersonalSheet(state) {
  const errors = { fields: {}, amounts: {} }
  if (state.target !== 'ja') return errors
  const sheet = resolvedPersonalSheet(state)
  const response = state.login_response || {}
  const persona = response.persona || {}
  const compare = (key, expected, signed = false) => {
    const actual = sheet.fields[key]
    if (isSheetBlank(actual)) errors.fields[key] = PERSONAL_FIELDS.some(field => field.key === key && field.automatic && key !== 'nmi') ? 'ログイン情報を確認できません。ログインし直してください。' : '入力してください。'
    else if (parseSheetAmount(expected, signed) === null) errors.fields[key] = '照合情報を確認できません。ログインし直してください。'
    else if (parseSheetAmount(actual, signed) !== parseSheetAmount(expected, signed)) errors.fields[key] = '個人情報カード・ログイン情報と一致しません。'
  }
  PERSONAL_FIELDS.filter(field => !field.hidden && !['spouse_age', 'child1_age', 'child2_age'].includes(field.key)).forEach(field => {
    compare(field.key, persona[field.key === 'nmi' ? 'net_monthly_income' : field.key], field.signed)
  })
  if (isSheetBlank(persona.is_married) || ![0, 1].includes(Number(persona.is_married))) {
    errors.fields.spouse_age = '配偶者の照合情報を確認できません。ログインし直してください。'
  } else if (Number(persona.is_married) === 0) {
    if (sheet.fields.is_married !== 'いない') errors.fields.spouse_age = '配偶者のログイン情報を確認できません。ログインし直してください。'
  } else if (sheet.fields.is_married !== 'いる') {
    errors.fields.spouse_age = '配偶者のログイン情報を確認できません。ログインし直してください。'
  } else {
    compare('spouse_age', (response.queryStringParameters || {}).spouse_age)
  }
  for (const key of ['child1_age', 'child2_age']) {
    if (isSheetBlank(persona[key])) {
      if (!isNoChild(sheet.fields[key])) errors.fields[key] = '子どもがいない場合は「いない」と入力してください。'
    } else compare(key, persona[key])
  }
  // Only genuinely blank rows opt out. Zero and invalid text both start full validation.
  if (FINANCE_LIMIT_ITEMS.some(({ key }) => !isSheetBlank(sheet.amounts[key]))) {
    const summary = buildFinanceSummary(state)
    for (const { key } of FINANCE_LIMIT_ITEMS) {
      const expected = key === 'life_insurance' ? summary.life_insurance_you + summary.life_insurance_spouse : summary[key]
      const value = sheet.amounts[key]
      if (isSheetBlank(value)) errors.amounts[key] = '全費目を入力してください。支出がない場合は0円です。'
      else if (parseSheetAmount(value) !== expected) errors.amounts[key] = `選択画面の金額は${expected.toLocaleString('ja-JP')}円です。`
    }
  }
  return errors
}

export function hasPersonalSheetErrors(errors) {
  return Object.keys(errors.fields).length + Object.keys(errors.amounts).length > 0
}
